<!--Main-->
<div class="widget-flex-box">
    <div class="widget-number-link">
        <a href="/#!/component/search" (click)="setSearchBy()"><h1><b>{{result.inspectionCount}}</b></h1></a>
    </div>

    <div class="widget-number-unit">
        <p>{{unit}}</p>
    </div>
</div>

<!--Subtext-->
<div class="widget-description" *ngIf="isIncludeSubtext" [ngClass]="isIncludeSubtext ? 'small-font' : ''">
    <h4><b>{{result.scrappedMonthCount}}</b> {{ui.description}}</h4>
</div>

